import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StoryPlayer from '../components/StoryPlayer';
import { FASTAPI_HOST } from '../settings/config';

function browserUiLanguage() {
  const locale = String(navigator.languages?.[0] || navigator.language || '').toLowerCase();
  if (locale.startsWith('zh-tw') || locale.startsWith('zh-hk') || locale.startsWith('zh-mo') || locale.includes('hant')) {
    return 'Traditional Chinese';
  }
  if (locale.startsWith('zh')) return 'Simplified Chinese';
  if (locale.startsWith('fr')) return 'French';
  return 'English';
}

export default function PublicStoryPlayerPage() {
  const { shareSlug } = useParams();
  const [media, setMedia] = useState([]);
  const [storyTitle, setStoryTitle] = useState('');
  const [uiLanguage] = useState(browserUiLanguage);
  const [translations, setTranslations] = useState({});
  const [error, setError] = useState('');
  const handlePracticeTalking = (context) => {
    sessionStorage.setItem('marstrix_practice_context', JSON.stringify({
      ...context,
      shareSlug,
    }));
    window.location.assign('/protected?practice=story');
  };

  useEffect(() => {
    fetch('/translations.json')
      .then((response) => response.json())
      .then(setTranslations)
      .catch((loadError) => console.warn('Failed to load translations:', loadError));
  }, []);

  useEffect(() => {
    async function fetchSharedStory() {
      try {
        setError('');
        const res = await fetch(`${FASTAPI_HOST}/api/public/story/${shareSlug}/media_info`);
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || `HTTP ${res.status}`);
        }
        const data = await res.json();
        setMedia(data.media || []);
        setStoryTitle(data.title || 'Shared Story');
      } catch (e) {
        setError(e?.message || 'Failed to load shared story');
      }
    }

    if (shareSlug) fetchSharedStory();
  }, [shareSlug]);

  if (error) {
    return (
      <div style={{ padding: 24, fontFamily: 'Roboto, Arial, sans-serif' }}>
        <h2>Shared story unavailable</h2>
        <div style={{ color: 'crimson' }}>{error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-transparent">
      <StoryPlayer
        media={media}
        storyTitle={storyTitle}
        onPracticeTalking={handlePracticeTalking}
        practiceLabel={translations?.[uiLanguage]?.scenario_practice || 'Scenario Practice'}
      />
    </div>
  );
}
